import { fromBase64 } from '@aws-sdk/util-base64'
import { encode } from 'js-base64'
import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue } from 'recoil'

import defaultWhiteBoardImg from '@/assets/images/defaultWhiteBoard.png'
import microphoneImg from '@/assets/images/mic-min.png'
import microphone1Img from '@/assets/images/mic-min1.png'
import useGetRecoilValue from '@/hooks/useGetRecoilValue'
import { penStateState, viewPicIdState } from '@/store/courseware'
import {
  audioLiveState,
  bigTeaAScreenState,
  BigWin,
  bigWinState,
  correctionState,
  enterBackgroundControlState,
  justUserState,
  paramsState,
  restState,
  syncStateState,
  useDeviceState,
  videoLiveStuState,
  WinStuId,
  WinStuName
} from '@/store/room'
import { Board, Conf, Lines } from '@/utils/board'
import { MediaType, RemoteUser } from '@/utils/rtc'
import { Network, networkQualityEnum, VolumeType } from '@/utils/rtc/agora'

import { roomEvent, rtcClient, rtmClient } from '../../../..'
import NetWork from '../../../Network'
import { position } from '../..'

export const mainStudentVideoBoard = new Board()
export const viceStudentVideoBoard = new Board()
export const justStudentVideoBoard = new Board()

export interface Win {
  index: BigWin
  id: WinStuId
  board: Board
}

export const idDiffName: { [key: string]: WinStuId } = {
  '20': 'mainStudent',
  '22': 'justStudent',
  '21': 'viceStudent'
}

export default function Index() {
  const timer = useRef<any>(null)
  const [correction, setCorrection] = useRecoilState(correctionState)
  const [justUser, setJustUser] = useRecoilState(justUserState)
  const [localJustStatus, setLocalJustStatus] = useState(false)
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const [volumeLevel, setVolumeLevel] = useState<WinStuName>({
    mainStudent: 0,
    viceStudent: 0,
    justStudent: 0
  }) // 0 ~ 100
  const [netWorkLevel, setNetWorkLevel] = useState<WinStuName>({
    mainStudent: 0,
    viceStudent: 0,
    justStudent: 0
  }) // 0 ~ 3
  const [params, getParams] = useGetRecoilValue(paramsState)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const [videoLiveStu, setVideoLiveStu] = useRecoilState(videoLiveStuState)
  const [audioLive, setAudioLive] = useRecoilState(audioLiveState)
  const [syncState, setSyncState] = useRecoilState(syncStateState)
  const [viewPicId, setViewPicId] = useRecoilState(viewPicIdState)
  const [draw, setDraw] = useState({
    mainStudent: 0,
    justStudent: 0,
    viceStudent: 0
  })
  const winRef = useRef<Win[]>([
    { index: 3, id: 'mainStudent', board: mainStudentVideoBoard },
    { index: 3, id: 'justStudent', board: justStudentVideoBoard },
    { index: 4, id: 'viceStudent', board: viceStudentVideoBoard }
  ])
  const rest = useRecoilValue(restState)
  const penState = useRecoilValue(penStateState)
  const enterBackgroundControl = useRecoilValue(enterBackgroundControlState)
  const bigTeaAScreen = useRecoilValue(bigTeaAScreenState)

  useEffect(() => {
    console.log('loadd Studdent video')
    // 远端和本地视频
    rtcClient.on('user-published', play)
    rtcClient.on('user-unpublished', unplay)
    rtcClient.on('media-ready', localPlay)
    rtcClient.on('media-close', unLocalPlay)
    // 音视频启用禁用
    rtcClient.on('unmute-video', localPlay)
    rtcClient.on('unmute-audio', localPlay)
    rtcClient.on('mute-video', unLocalPlay)
    rtcClient.on('mute-audio', unLocalPlay)
    // 麦震、网络
    rtcClient.on('volume-indicator', volumeIndicator)
    rtcClient.on('network-quality', networkQuality)
    // 视频白板画线
    mainStudentVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    viceStudentVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    justStudentVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    // 视频白板配置更新
    mainStudentVideoBoard.on('conf', (conf) => boardConf(conf, 'mainStudent'))
    viceStudentVideoBoard.on('conf', (conf) => boardConf(conf, 'viceStudent'))
    justStudentVideoBoard.on('conf', (conf) => boardConf(conf, 'justStudent'))

    // 注册白板
    // console.log(JSON.stringify(winRef.current))
    winRef.current.forEach((v, i) => {
      const ele = document.querySelector(`#videoBoard_${v.id}`)
      v.board.create(ele as unknown as HTMLDivElement)
      let win = ''
      if (v.id === 'mainStudent') win = params.mainStudentId
      if (v.id === 'viceStudent') win = params.viceStudentId
      if (v.id === 'justStudent') win = params.justStudentId
      v.board.init({
        windowId: win,
        url: defaultWhiteBoardImg
      })
    })

    return () => {
      rtcClient.removeListener('user-published', play)
      rtcClient.removeListener('user-unpublished', unplay)
      rtcClient.removeListener('media-ready', localPlay)
      rtcClient.removeListener('media-close', unLocalPlay)

      rtcClient.removeListener('unmute-video', localPlay)
      rtcClient.removeListener('unmute-audio', localPlay)
      rtcClient.removeListener('mute-video', unLocalPlay)
      rtcClient.removeListener('mute-audio', unLocalPlay)

      rtcClient.removeListener('volume-indicator', volumeIndicator)
      rtcClient.removeListener('network-quality', networkQuality)

      mainStudentVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)
      viceStudentVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)
      justStudentVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)

      mainStudentVideoBoard.removeListener('conf', boardConf)
      viceStudentVideoBoard.removeListener('conf', boardConf)
      justStudentVideoBoard.removeListener('conf', boardConf)

      timer.current && clearTimeout(timer.current)
    }
  }, [])

  // 大屏监听
  useEffect(() => {
    // 视频画板resize和可画状态
    setTimeout(() => {
      // console.log(bigWin, winRef.current)
      winRef.current.forEach((v) => {
        v.board._resize()
        if (v.index === bigWin && !bigTeaAScreen) {
          !penState && v.board.setConf({ tool: 1 })
        } else {
          v.board.setConf({ tool: 0 })
        }
      })
    }, 350)
  }, [bigWin, bigTeaAScreen, videoLiveStu, penState])

  // 发送画线
  const emitArtDrawLine = useCallback((lineData: Lines) => {
    rtmClient.sendMessage('ArtDrawLine', lineData)
  }, [])

  // 配置更新，用于鼠标样式
  const boardConf = useCallback((conf: Conf, id: string) => {
    setDraw((v) => ({ ...v, [id]: conf.tool }))
  }, [])

  // 远端音视频播放(isStreamEffect 是否为流触发,否则为自己触发)
  const play = useCallback((mediaType: MediaType, remoteUser: RemoteUser, isStreamEffect: boolean = true) => {
    const uid: string = remoteUser.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (!id) {
      return
    }
    if (id === 'justStudent' && isStreamEffect) {
      roomEvent.emit('localJustChange', true)
    }
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      ele.innerHTML = ''
      rtcClient.play(remoteUser.videoTrack, ele, { fit: 'contain', type: 'remote' })
      setVideoLiveStu((v) => ({ ...v, [id]: 1 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: true }))
    }
  }, [])

  // 远端音视频关闭
  const unplay = useCallback((mediaType: MediaType, remoteUser: RemoteUser, isStreamEffect: boolean = true) => {
    const uid: string = remoteUser.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (!id) {
      return
    }
    if (id === 'justStudent' && isStreamEffect) {
      roomEvent.emit('localJustChange', false)
      justStudentVideoBoard.clear(3)
    }
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      ele.innerHTML = ''
      setVideoLiveStu((v) => ({ ...v, [id]: 0 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: false }))
    }
  }, [])

  // 本地音视频播放
  const localPlay = useCallback((mediaType: MediaType, user: RemoteUser) => {
    console.log('mediaType', mediaType, user)
    const uid: string = user.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      if (ele && user.videoTrack) {
        ele.innerHTML = ''
        rtcClient.play(user.videoTrack, ele, { fit: 'cover', mirror: false, type: 'local' })
      }
      setVideoLiveStu((v) => ({ ...v, [id]: 1 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: true }))
    }
  }, [])

  // 本地音视频关闭
  const unLocalPlay = useCallback((mediaType: MediaType, user: { uid: number }, code?: number) => {
    const uid: string = user.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      ele.innerHTML = ''
      setVideoLiveStu((v) => ({ ...v, [id]: code || 0 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: false }))
    }
  }, [])

  // 麦震
  const volumeIndicator = useCallback((volumes: VolumeType[]) => {
    const vol: WinStuName = {
      mainStudent: 0,
      viceStudent: 0,
      justStudent: 0
    }
    volumes.forEach((v) => {
      const id: string = v.uid.toString()
      vol[idDiffName[id.slice(0, 2)]] = v.level
    })
    setVolumeLevel(vol)
  }, [])

  // 网络
  const networkQuality = useCallback((network: Network) => {
    const net: WinStuName = {
      mainStudent: 0,
      viceStudent: 0,
      justStudent: 0
    }
    const local = network.local
    const remote = network.remote
    Object.keys(remote).forEach((v) => {
      const id: string = v.toString()
      const remoteNet = remote[v]
      net[idDiffName[id.slice(0, 2)]] = remoteNet ? networkQualityEnum[remoteNet.downlinkNetworkQuality] : 0
    })
    setNetWorkLevel({ ...net, mainStudent: networkQualityEnum[local.uplinkNetworkQuality] || 0, viceStudent: networkQualityEnum[local.uplinkNetworkQuality] || 0 })
  }, [])

  // 视频上台
  const goDesk = (id: WinStuId, index: BigWin) => {
    // let inRoom = false
    // if (id === 'mainStudent') {
    //   inRoom = !!rtcClient.localMainVideoTrack
    // } else if (id === 'viceStudent') {
    //   inRoom = !!rtcClient.localViceVideoTrack
    // } else {
    //   inRoom = !!rtcClient.remoteVideoTrack.find((v) => {
    //     const uid: string = v.uid.toString()
    //     return id === idDiffName[uid.slice(0, 2)]
    //   })
    // }
    // if (inRoom) {
    //   setBigWin(index)
    // } else {
    //   toast('视频未连接')
    // }
  }

  const bg = (id: WinStuId) => {
    // 课间休息
    if (rest.state === 1) {
      return 'bg-stu-rest bg-cover'
    }
    // 切到后台运行
    if (enterBackgroundControl && videoLiveStu[id] !== 0) {
      return 'bg-back'
    }
    // 有流
    if (videoLiveStu[id] === 1) {
      return ''
    }
    // 没有流
    if (videoLiveStu[id] === 0) {
      return 'bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003]'
    }
    // 关闭流
    if (videoLiveStu[id] === 2) {
      return 'bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003]'
    }
  }

  const hidden = (id: WinStuId) => {
    // 存在老师just，老师主窗口隐藏
    if (id === 'mainStudent' && justUser[params.mainStudentId]) {
      return 'hidden'
    }
    // 不存在老师just，老师Just窗口隐藏
    if (id === 'justStudent' && !justUser[params.mainStudentId]) {
      return 'hidden'
    }
    return ''
  }

  // 监听just信息变化更新视频
  useUpdateEffect(() => {
    setLocalJustStatus(justUser[params.mainStudentId] || false)
  }, [justUser])

  useUpdateEffect(() => {
    const justVideoTrack = rtcClient.remoteVideoTrack.find((v) => v.uid.toString().slice(0, 2) === '22')
    if (localJustStatus) {
      rtcClient.deviceOff('mainVideo').catch(() => rtcClient.changeMainCamera({ deviceId: '' }))
      justVideoTrack && play('video', justVideoTrack, false)
    } else {
      rtcClient.deviceOn('mainVideo').catch(() => {
        useDevice.mainCamera && rtcClient.changeMainCamera({ deviceId: useDevice.mainCamera })
      })
      justVideoTrack && unplay('video', justVideoTrack, false)
    }
    if (bigWin === 3 && !bigTeaAScreen) {
      if (localJustStatus) {
        mainStudentVideoBoard.setConf({ tool: 0 })
        !penState && justStudentVideoBoard.setConf({ tool: 1 })
      } else {
        !penState && mainStudentVideoBoard.setConf({ tool: 1 })
        mainStudentVideoBoard._resize()
        justStudentVideoBoard.setConf({ tool: 0 })
      }
    }
  }, [localJustStatus])

  // 学员退出、掉线窗口处理
  // useUpdateEffect(() => {
  //   if (videoLiveStu.mainStudent === 0 && bigWin === 4) {
  //     setBigWin(1)
  //   }
  // }, [videoLiveStu.mainStudent])
  // useUpdateEffect(() => {
  //   if (videoLiveStu.viceStudent === 0 && bigWin === 5) {
  //     setBigWin(1)
  //   }
  // }, [videoLiveStu.viceStudent])
  // useUpdateEffect(() => {
  //   if (videoLiveStu.justStudent === 0 && bigWin === 4) {
  //     //
  //   }
  // }, [videoLiveStu.justStudent])

  return (
    <>
      {winRef.current.map((v) => (
        <div key={v.id} className={`w-full h-[22.5vh] ${hidden(v.id)}`}>
          <div className={`${bg(v.id)} bg-center ${draw[v.id] === 1 ? 'brush-border-box' : ''} ${position[bigWin === v.index ? 1 : v.index]} bg-center`} onClick={() => goDesk(v.id, v.index)}>
            {videoLiveStu[v.id] ? (
              <div className={`absolute z-10 flex justify-between items-center w-full h-[2.1vh] px-[0.3vh] left-0 bottom-[0.3vh]`}>
                <NetWork level={netWorkLevel[v.id]} />
                {v.id === 'mainStudent' ? (
                  <div className="relative w-[1.8vh] h-[2.6vh] flex justify-end items-center">
                    <img className="" src={!audioLive[v.id] ? microphoneImg : microphone1Img} alt="" />
                    <div className="flex items-end absolute rounded-[0.7vh] overflow-hidden left-[0.45vh] top-[0.2vh] w-[0.85vh] h-[1.52vh]">
                      <div style={{ height: `${volumeLevel[v.id]}%` }} className="w-full bg-gradient-to-b bg-[#92FF33]"></div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div id={`video_${v.id}`} className={`w-full h-full ${enterBackgroundControl && videoLiveStu[v.id] !== 0 ? 'hidden' : ''}`}></div>
            <div
              id={`videoBoard_${v.id}`}
              className={`${draw[v.id] === 1 ? 'pen' : ''} ${enterBackgroundControl || videoLiveStu[v.id] !== 1 ? 'hidden' : ''} w-full h-full overflow-hidden absolute top-0 left-0`}
            ></div>
          </div>
        </div>
      ))}
    </>
  )
}

export const Temp = () => {
  return (
    <>
      <div className={`w-full h-[22.5vh]`}>
        <div className={`bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003] bg-center ${position[3]}`}></div>
      </div>
      <div className={`w-full h-[22.5vh]`}>
        <div className={`bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003] bg-center ${position[4]}`}></div>
      </div>
    </>
  )
}
